import { useSelector } from 'react-redux';

const useIsDeepTech = () => {
  const profileInfo = useSelector((state) => state.profile.profileInfo);
  return profileInfo?.data?.profile?.current_program === "deeptech" && profileInfo?.data?.profile?.deep_tech_profile;
};

export default useIsDeepTech;